function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import { AllMenusQuery, Html, Link } from "@custom/schema";
import { zodResolver } from "@hookform/resolvers/zod";
import clsx from "clsx";
import React, { useRef } from "react";
import { ArrowRight } from "react-feather";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { useDomain } from "../../../utils/domain";
import { useLocalization } from "../../../utils/localization";
import { menuItems } from "../../../utils/navigation";
import { useOperation } from "../../../utils/operation";
import { buildUrl } from "../../../utils/url";
import { Button } from "../../Atoms/Button";
import { CrossIcon } from "../../Atoms/Icons/CrossIcon";
import { FooterSocialIcon } from "../../Atoms/Icons/FooterSocials";
import { Logo } from "../../Atoms/Logo";
export var EmployerBranding = function EmployerBranding() {
  var t = useTranslation().t;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row justify-between gap-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "leading-160% text-14 md:text-16 font-bold mb-2"
  }, t("employer_branding.title")), /*#__PURE__*/React.createElement("p", {
    className: "text-14 md:text-16 leading-160%"
  }, t("employer_branding.description")), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row gap-7"
  }, /*#__PURE__*/React.createElement(FooterLink, {
    href: t("employer_branding.cta_1.url"),
    variant: "white",
    size: "small"
  }, t("employer_branding.cta_1.text")), /*#__PURE__*/React.createElement(FooterLink, {
    href: t("employer_branding.cta_2.url"),
    variant: "white",
    size: "small",
    rel: "noreferrer"
  }, t("employer_branding.cta_2.text")))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row gap-5 md:gap-8 w-fit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-w-max"
  }, /*#__PURE__*/React.createElement("img", {
    src: t("employer_branding.badges.one.img"),
    alt: t("employer_branding.badges.one.alt"),
    className: "h-20 md:h-30 w-auto"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-w-max"
  }, /*#__PURE__*/React.createElement("img", {
    src: t("employer_branding.badges.two.img"),
    alt: t("employer_branding.badges.two.alt"),
    className: "h-20 md:h-30 w-auto"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "h-px bg-primary-white/20 w-full my-12 md:my-15"
  }));
};
// PROD hotfix only.
// See https://amazeelabs.slack.com/archives/C05NB79EHJR/p1703082287676519
var backendUrl = "https://backend.paraplegie.ch";
// Anything without a idHash is seen as a fake field by the backend.
var idHash = "dgGGpn";
var newsLetterSchema = z.object(_define_property({}, "email".concat(idHash), z.string().email()));
export var FooterNewsletterForm = function FooterNewsletterForm() {
  var locale = useLocalization().locale;
  var t = useTranslation().t;
  var _useForm = useForm({
      resolver: zodResolver(newsLetterSchema)
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control;
  var formRef = useRef(null);
  return /*#__PURE__*/React.createElement("form", {
    ref: formRef,
    method: "GET",
    className: "bg-primary-white rounded-full ps-6 inline-flex w-full max-w-80 h-12 items-center",
    autoComplete: "off",
    action: buildUrl([backendUrl, locale, "newsletter-sign-up"]),
    onSubmit:
    //validate the form first then do the action
    handleSubmit(function () {
      var _formRef_current;
      (_formRef_current = formRef.current) === null || _formRef_current === void 0 ? void 0 : _formRef_current.submit();
    })
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "form".concat(idHash),
    value: "20"
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "time".concat(idHash),
    value: Date.now()
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, t("F\xfcr Newsletter der Paraplegiker Stiftung anmelden")), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "email".concat(idHash),
    render: function render(param) {
      var field = param.field;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
        className: "sr-only"
      }, t("Email *")), /*#__PURE__*/React.createElement("input", _object_spread({
        type: "email",
        placeholder: t("Email address"),
        required: true,
        className: "border-0 bg-transparent p-0 placeholder:text-primary-black text-primary-black focus:border-0 focus:ring-0 w-full leading-160% text-16"
      }, field)));
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: "bg-theme-action text-primary-white rounded-full me-0.5 h-11 w-11 flex items-center justify-center min-w-11",
    type: "submit",
    "aria-label": t("Subscribe")
  }, /*#__PURE__*/React.createElement(CrossIcon, null)));
};
export var NewsletterSignupButton = function NewsletterSignupButton(param) {
  var url = param.url,
    label = param.label;
  return /*#__PURE__*/React.createElement(Link, {
    className: "Button cta-white",
    type: "button",
    href: url
  }, /*#__PURE__*/React.createElement("span", {
    className: "Button--text"
  }, label), /*#__PURE__*/React.createElement("span", {
    className: "LinkList--link--icon"
  }, /*#__PURE__*/React.createElement("i", {
    className: "ico ico-bolt-right-white"
  })));
};
var FooterOrganization = function FooterOrganization(param) {
  var data = param.data;
  var locale = useLocalization().locale;
  var domain = useDomain();
  var quickLinksItems = domain.quickLinksMenu ? menuItems(domain.quickLinksMenu, data, locale) : [];
  var organisationFooterSocialMenuItems = domain.organisationFooterSocialMenu ? menuItems(domain.organisationFooterSocialMenu, data, locale) : null;
  return /*#__PURE__*/React.createElement(FooterBase, {
    menuItems: quickLinksItems,
    socialMenuItems: organisationFooterSocialMenuItems !== null && organisationFooterSocialMenuItems !== void 0 ? organisationFooterSocialMenuItems : [],
    variant: "organisation"
  });
};
var FooterBase = function FooterBase(param) {
  var menuItems = param.menuItems,
    socialMenuItems = param.socialMenuItems,
    _param_variant = param.variant,
    variant = _param_variant === void 0 ? "group" : _param_variant;
  var _domain_newsletterUrls;
  var domain = useDomain();
  var t = useTranslation().t;
  var locale = useLocalization().locale;
  var newsletterUrl = (_domain_newsletterUrls = domain.newsletterUrls) === null || _domain_newsletterUrls === void 0 ? void 0 : _domain_newsletterUrls[locale];
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10 lg:gap-16"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-fit"
  }, /*#__PURE__*/React.createElement(Logo, {
    variant: variant === "group" ? "default-white" : "domain",
    size: "small",
    hasPadding: false
  })), variant === "group" && domain.id === "paraplegie_ch" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "sr-only"
  }, t("Contact")), /*#__PURE__*/React.createElement(FooterContact, {
    variant: "group"
  })), variant === "organisation" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "sr-only"
  }, t("Contact")), /*#__PURE__*/React.createElement(FooterContact, {
    variant: "organisation"
  }))), menuItems.length > 0 && /*#__PURE__*/React.createElement("div", null, variant === "organisation" ? /*#__PURE__*/React.createElement("h2", {
    className: "font-bold leading-160% mb-4",
    id: "footer-links-title"
  }, t("Quick Links")) : /*#__PURE__*/React.createElement("h2", {
    className: "sr-only",
    id: "footer-links-title"
  }, t("Links")), /*#__PURE__*/React.createElement("ul", {
    className: "flex flex-col gap-2",
    "aria-labelledby": "footer-links-title"
  }, menuItems.filter(function (menuItem) {
    var _menuItem_attributes;
    return !!(menuItem === null || menuItem === void 0 ? void 0 : (_menuItem_attributes = menuItem.attributes) === null || _menuItem_attributes === void 0 ? void 0 : _menuItem_attributes.enabled);
  }).map(function (menuItem) {
    var _menuItem_childItems, _menuItem_childItems1, _menuItem_childItems2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, ((_menuItem_childItems = menuItem.childItems) === null || _menuItem_childItems === void 0 ? void 0 : _menuItem_childItems.length) && ((_menuItem_childItems1 = menuItem.childItems) === null || _menuItem_childItems1 === void 0 ? void 0 : _menuItem_childItems1.length) > 0 ? /*#__PURE__*/React.createElement("li", {
      className: "flex flex-col gap-2",
      key: menuItem.id
    }, /*#__PURE__*/React.createElement(Link, {
      href: menuItem.url,
      className: clsx("font-bold leading-160% mb-2 w-fit rounded-1", variant === "organisation" ? "focus-visible:!outline-primary-black" : "focus-visible:!outline-primary-white")
    }, menuItem.title), /*#__PURE__*/React.createElement("ul", {
      className: "flex flex-col gap-2"
    }, (_menuItem_childItems2 = menuItem.childItems) === null || _menuItem_childItems2 === void 0 ? void 0 : _menuItem_childItems2.map(function (child) {
      return /*#__PURE__*/React.createElement("li", {
        key: child.id
      }, /*#__PURE__*/React.createElement(FooterLink, {
        href: child.url,
        variant: variant === "group" ? "white" : "black"
      }, child.title));
    }))) : /*#__PURE__*/React.createElement("li", {
      key: menuItem.id
    }, /*#__PURE__*/React.createElement(FooterLink, {
      href: menuItem.url,
      variant: variant === "group" ? "white" : "black"
    }, menuItem.title)));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-10"
  }, (socialMenuItems === null || socialMenuItems === void 0 ? void 0 : socialMenuItems.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex  flex-col gap-3"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "leading-160% font-bold",
    id: "footer-social-title"
  }, variant === "group" ? t("footer.socialMenuTitle") : t("{{domain}} {{subtext}}", {
    domain: t(domain.title),
    subtext: t("footer_organisation.socialMenuTitleSubtext")
  })), /*#__PURE__*/React.createElement("ul", {
    className: "flex flex-row gap-3 flex-wrap h-fit",
    "aria-labelledby": "footer-social-title"
  }, socialMenuItems === null || socialMenuItems === void 0 ? void 0 : socialMenuItems.map(function (menuItem) {
    var _menuItem_title;
    return /*#__PURE__*/React.createElement("li", {
      key: menuItem.id
    }, /*#__PURE__*/React.createElement(FooterSocial, {
      icon: (_menuItem_title = menuItem.title) === null || _menuItem_title === void 0 ? void 0 : _menuItem_title.toString().toLowerCase(),
      variant: variant === "group" ? "white" : "black",
      url: menuItem.url
    }));
  }))), locale !== "en" && (variant === "group" ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "leading-160% font-bold"
  }, t("Newsletter")), /*#__PURE__*/React.createElement(FooterNewsletterForm, null)) : newsletterUrl && /*#__PURE__*/React.createElement("div", {
    className: "w-fit"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    href: newsletterUrl,
    size: "small",
    icon: /*#__PURE__*/React.createElement(ArrowRight, null)
  }, t("footer.newsletter.cta"))))));
};
export function Footer(param) {
  var hideEmployerBranding = param.hideEmployerBranding;
  var domain = useDomain();
  var locale = useLocalization().locale;
  var _useOperation = useOperation(AllMenusQuery),
    menus = _useOperation.data;
  var footerMenuItems = menuItems(domain.footerMenu || "footer-menu", menus, locale);
  var footerSocialMenuItems = menuItems(domain.footerSocialMenu || "footer-social-menu", menus, locale);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("footer", {
    className: clsx("pb-15", {
      "bg-theme-light rounded-tr-7.5 md:rounded-tr-20": domain.id !== "paraplegie_ch"
    })
  }, domain.id !== "paraplegie_ch" && /*#__PURE__*/React.createElement("div", {
    className: "container-narrow-content lg:!pe-[7.25rem] py-15"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content text-primary-black"
  }, menus && /*#__PURE__*/React.createElement(FooterOrganization, {
    data: menus
  }))), /*#__PURE__*/React.createElement("div", {
    className: "bg-primary-dark-grey pt-12 pb-15 rounded-r-7.5 md:rounded-r-20 lg:me-10 theme-default"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-narrow-content lg:!pe-[7.25rem]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content text-primary-white"
  }, locale === "de" && !hideEmployerBranding && /*#__PURE__*/React.createElement(EmployerBranding, null), /*#__PURE__*/React.createElement(FooterBase, {
    menuItems: footerMenuItems,
    socialMenuItems: footerSocialMenuItems,
    variant: "group"
  }))))));
}
var FooterContact = function FooterContact(param) {
  var _param_variant = param.variant,
    variant = _param_variant === void 0 ? "group" : _param_variant;
  var t = useTranslation().t;
  var domain = useDomain();
  var id = variant === "group" ? "paraplegie_ch" : domain.id;
  var linkVariant = variant === "group" ? "white" : "black";
  switch (id) {
    case "paraplegie_ch":
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col gap-10"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: "font-bold"
      }, t("zentrum_paraplegie_ch.title")), "Guido A. Z\xe4ch Strasse 1", /*#__PURE__*/React.createElement("br", null), "6207 Nottwil", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "mailto:spz@paraplegie.ch",
        variant: linkVariant
      }, "spz@paraplegie.ch"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41419395454",
        variant: linkVariant
      }, "+41 41 939 54 54")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: "font-bold"
      }, t("stiftung_paraplegie_ch.title"), /*#__PURE__*/React.createElement("br", null), t("footer.contact.sps.label")), "Guido A. Z\xe4ch Strasse 6", /*#__PURE__*/React.createElement("br", null), "6207 Nottwil", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "mailto:sps@paraplegie.ch",
        variant: linkVariant
      }, "sps@paraplegie.ch"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41419396262",
        variant: linkVariant
      }, "+41 41 939 62 62")));
    case "sportmedizin_paraplegie_ch":
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col gap-10"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: "font-bold"
      }, t("sportmedizin_paraplegie_ch.title")), "Guido A. Z\xe4ch Strasse 1", /*#__PURE__*/React.createElement("br", null), "6207 Nottwil", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "mailto:sportmedizin@sportmedizin-nottwil.ch",
        variant: linkVariant
      }, "sportmedizin@sportmedizin-nottwil.ch"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41419396600",
        variant: linkVariant
      }, "+41 41 939 66 00")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Html, {
        markup: t("footer.contact.sportmedizin.registration")
      })));
    case "sirmed_paraplegie_ch":
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: "font-bold uppercase"
      }, t("sirmed_paraplegie_ch.title")), t("footer.contact.sirmed.label"), /*#__PURE__*/React.createElement("br", null), "Guido A. Z\xe4ch Strasse 2b", /*#__PURE__*/React.createElement("br", null), "6207 Nottwil", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "mailto:info@sirmed.ch",
        variant: linkVariant
      }, "info@sirmed.ch"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41419395050",
        variant: linkVariant
      }, "+41 41 939 50 50"));
    case "activecommunication_paraplegie_ch":
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: "font-bold"
      }, t("ac_paraplegie_ch.title")), "Sumpfstrasse 28", /*#__PURE__*/React.createElement("br", null), "6312 Steinhausen", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "mailto:office@activecommunication.ch",
        variant: linkVariant
      }, "office@activecommunication.ch"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41417470303",
        variant: linkVariant
      }, "+41 41 747 03 03"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41417470300",
        variant: linkVariant
      }, "+41 41 747 03 00 (Service-Center D)"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41417470312",
        variant: linkVariant
      }, "+41 41 747 03 12 (Service-Center F)"), /*#__PURE__*/React.createElement("br", null));
    case "forschung_paraplegie_ch":
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: "font-bold"
      }, t("forschung_paraplegie_ch.title")), "Guido A. Z\xe4ch-Strasse 4", /*#__PURE__*/React.createElement("br", null), "6207 Nottwil", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "mailto:spf@paraplegie.ch",
        variant: linkVariant
      }, "spf@paraplegie.ch"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41419396565",
        variant: linkVariant
      }, "+41 41 939 65 65"));
    case "orthotec_paraplegie_ch":
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: "font-bold"
      }, t("orthotec_paraplegie_ch.title"), " AG"), "Guido A. Z\xe4ch Strasse 1", /*#__PURE__*/React.createElement("br", null), "6207 Nottwil ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "mailto:info@orthotec.ch",
        variant: linkVariant
      }, "info@orthotec.ch"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41419395606",
        variant: linkVariant
      }, "+41 41 939 56 06"));
    case "orthotecsports_paraplegie_ch":
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: "font-bold"
      }, t("orthotec_paraplegie_ch.title"), " AG"), "Guido A. Z\xe4ch Strasse 1", /*#__PURE__*/React.createElement("br", null), "6207 Nottwil ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "mailto:info@orthotec.ch",
        variant: linkVariant
      }, "info@orthotec.ch"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41419395606",
        variant: linkVariant
      }, "+41 41 939 56 06"));
    case "stiftung_paraplegie_ch":
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: "font-bold"
      }, t("stiftung_paraplegie_ch.title")), "Guido A. Z\xe4ch Strasse 10", /*#__PURE__*/React.createElement("br", null), "6207 Nottwil", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "mailto:sps.sec@paraplegie.ch",
        variant: linkVariant
      }, "sps.sec@paraplegie.ch"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41419396363",
        variant: linkVariant
      }, "+41 41 939 63 63"));
    case "zentrum_paraplegie_ch":
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: "font-bold"
      }, t("zentrum_paraplegie_ch.title")), "Guido A. Z\xe4ch-Strasse 1", /*#__PURE__*/React.createElement("br", null), "6207 Nottwil", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "mailto:spz@paraplegie.ch",
        variant: linkVariant
      }, "spz@paraplegie.ch"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41419395454",
        variant: linkVariant
      }, "+41 41 939 54 54"), /*#__PURE__*/React.createElement("br", null));
    case "parahelp_paraplegie_ch":
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: "font-bold"
      }, t("parahelp_paraplegie_ch.title"), " AG"), "Guido A. Z\xe4ch-Strasse 1", /*#__PURE__*/React.createElement("br", null), "6207 Nottwil", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "mailto:info@parahelp.ch",
        variant: linkVariant
      }, "info@parahelp.ch"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FooterLink, {
        href: "tel:+41419396060",
        variant: linkVariant
      }, "+41 41 939 60 60"));
  }
};
var FooterSocial = function FooterSocial(param) {
  var icon = param.icon,
    _param_variant = param.variant,
    variant = _param_variant === void 0 ? "white" : _param_variant,
    url = param.url;
  return /*#__PURE__*/React.createElement(Link, {
    href: url,
    className: clsx("h-7 w-7 rounded-1 hover:text-theme-action inline-flex items-center justify-center transition-colors duration-200 ease-in-out min-w-7", variant === "white" ? "bg-primary-white text-primary-dark-grey focus-visible:!outline-primary-white" : "bg-primary-black text-primary-white focus-visible:!outline-primary-black")
  }, /*#__PURE__*/React.createElement(FooterSocialIcon, {
    icon: icon
  }));
};
var FooterLink = function FooterLink(param) {
  var href = param.href,
    children = param.children,
    _param_variant = param.variant,
    variant = _param_variant === void 0 ? "black" : _param_variant,
    _param_size = param.size,
    size = _param_size === void 0 ? "regular" : _param_size,
    rel = param.rel;
  return /*#__PURE__*/React.createElement("div", {
    className: "inline-flex items-baseline gap-1 rounded-1.25"
  }, /*#__PURE__*/React.createElement("span", {
    className: "translate-y-0.5"
  }, /*#__PURE__*/React.createElement(ArrowRight, {
    "aria-hidden": "true",
    className: "h-4 w-4"
  })), /*#__PURE__*/React.createElement(Link, {
    href: href,
    rel: rel,
    className: clsx("relative w-fit rounded-1.25", variant === "black" ? " focus-visible:!outline-primary-black" : " focus-visible:!outline-primary-white", size === "small" && "text-14 font-juneau", variant === "black" ? "text-primary-black" : "text-primary-white")
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx("bg-[length:0_1px,100%_1px] bg-no-repeat bg-[position:0_100%,0_100%] hover:bg-[length:100%_1px,0_1px] transition-[background-size] duration-300", variant === "black" ? "bg-gradient-to-r from-primary-black to-primary-black,  to-primary-black" : "bg-gradient-to-r from-primary-white to-primary-white,  to-primary-white")
  }, children)));
};